// extracted by mini-css-extract-plugin
export default {"warning":"alert_warning__5xaOU","slideDown":"alert_slideDown__F+vfb","success":"alert_success__Wr5XP"};